import React from "react";
import { Chart } from "primereact/chart";
import ChartDivider from "../../ChartDivider";
import ChartSkeleton from "../../../Skeletons/ChartSkeleton";
import { getHmlChartOptions } from "../../../../utils/chartOptions/dashboard/frequency";

const HMLFrequency = React.memo(function UsesPerDay(props) {
  const options = getHmlChartOptions(props?.hmlGraph);
  return (
    <>
      <div className="mt-4" style={{ maxWidth: "100%" }}>
        <div className="mb-4">
          <h5 className="fw-bold mb-2 text-start">UseSights Frequency Tiers</h5>
          {/* <h6 className="fw-bold mb-2 text-start">Base: Products</h6> */}
          <p
            className="mb-0 text-start fw-bold fs-12 pb-3"
            style={{ color: "#6c757d" }}
          >
            Products segmented into tertiles based on average weekly frequency
          </p>
          <div className="col-12">
            {!props?.hmlLoader ? (
              <Chart
                redraw={(props?.isFilterHide || props?.showSidebar).toString()}
                type="bar"
                data={props?.hmlGraph}
                options={options}
              />
            ) : (
              <ChartSkeleton />
            )}
          </div>
          <ChartDivider />
        </div>
      </div>
    </>
  );
});

export default HMLFrequency;
